<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
    <path
      fill="currentColor"
      d="M6 .025a.94.94 0 0 0-.935.848l-.004.083V5.06H.964l-.082.004H.874A.94.94 0 0 0 .024 6l.005.083v.007a.94.94 0 0 0 .935.85h4.097v4.096l.004.083v.007a.94.94 0 0 0 .935.85l.082-.004.008-.001a.94.94 0 0 0 .849-.935V6.94h4.097l.082-.003.008-.001a.94.94 0 0 0 .85-.935l-.005-.082V5.91a.94.94 0 0 0-.935-.849H6.939V.964L6.935.88V.873A.94.94 0 0 0 6 .025Z"
    />
  </svg>
</template>
